import React, {useEffect} from 'react';
import {getInitialCmsPageSharedValues, useCmsData, PageData, getUrlPattern} from 'epic-ue-shared';
import {getHelmetForMetaTags} from './utils/epicGamesUtils';
import root from 'window-or-global';
import styled from 'styled-components';
import {useLocation} from 'react-router-dom';
import {modeKey} from './App';
import {processCmsContentForGameMode} from './utils/cmsUtils';
import LoadIndicator from './components/common/loading/LoadIndicator';
import {useSharedValue} from '@epic-core/hooks';
import Error404 from './views/error/Error404';
import {Banner} from './components/banner';

const scrollIntoView = (): void => {
    setTimeout(() => {
        const id = root.location && root.location.hash && root.location.hash.replace('#', '');
        if (id) {
            const element = root.document.getElementById(id);
            if (element) {
                element.scrollIntoView();
            }
        }
    }, 100);
};

const Blank = styled.div`
    table td {
        padding: 8px;
        border: 1px solid black;
        white-space: normal;
    }
    a {
        word-wrap: break-word;
    }
    .table-container {
        overflow: scroll;
        white-space: nowrap;
    }
    .table-container a {
        word-wrap: unset;
    }

    background-color: white;
    h1 {
        font-size: 2.4em;
        padding-bottom: 0.5em;
        font-weight: bold;
        text-transform: uppercase;
    }

    h2 {
        font-size: 1.6em;
    }

    h3 {
        font-size: 1.4em;
    }

    h4 {
        font-size: 1.2em;
    }

    h1,
    h2,
    h3,
    h4 {
        font-family: Brutal, Brutal_Medium, Arial, sans-serif;
    }
`;

interface BlankPageData extends PageData {
    content: string;
    bannerContent?: string;
}

const PAGES_IN_GAME = ['/tos', '/privacypolicy', '/fan-art-policy'];

const CmsPage = (): JSX.Element => {
    const {pathname} = useLocation();
    const pageSlug = getUrlPattern({pathname});
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<BlankPageData>(pageSlug);
    const [mode] = useSharedValue(modeKey);

    useEffect(() => {
        scrollIntoView();
    }, []);

    if (cmsLoading) {
        return (
            <div className="cms-page">
                {getHelmetForMetaTags(pageData)}
                <LoadIndicator />
            </div>
        );
    }

    const content = pageData.content;
    const bannerContent = pageData.bannerContent || '';

    if (cmsLoadedEmpty || !content) {
        return <Error404 />;
    }

    const finalContent = processCmsContentForGameMode(content, mode, PAGES_IN_GAME);
    const slugNoSlash = pageSlug.replace(/\//, '');

    return (
        <div className="cms-page">
            {getHelmetForMetaTags(pageData)}
            <Blank>
                {bannerContent ? (
                    <Banner className="banner">
                        <div
                            className="banner-content"
                            dangerouslySetInnerHTML={{__html: bannerContent}}
                        />
                    </Banner>
                ) : null}
                <div
                    className={`cms-page-content ${slugNoSlash} container`}
                    dangerouslySetInnerHTML={{__html: finalContent}}
                />
            </Blank>
        </div>
    );
};

CmsPage.getInitialSharedValues = getInitialCmsPageSharedValues();

export default CmsPage;
